import { render } from "./CometChatGroupList.vue?vue&type=template&id=2b402ae7&scoped=true"
import script from "./CometChatGroupList.vue?vue&type=script&lang=js"
export * from "./CometChatGroupList.vue?vue&type=script&lang=js"

import "./CometChatGroupList.vue?vue&type=style&index=0&id=2b402ae7&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b402ae7"]])

export default __exports__